/**
 * Contexto de la OFERTA organic native (F5c) en sessionStorage. Los inputs
 * actuariales (autodeclarados) se recogen a lo largo del funnel y el upsell los
 * necesita para re-preparar el quote con 3 capitales:
 *   - calculator (postLeadOrganic): birthDate, gender, smoker, capital.
 *   - cuestionario médico (confirm): imc real (de altura/peso) → se parchea aquí,
 *     para que el upsell re-tarifique con el MISMO imc que el quote (no el fallback).
 *
 * Solo per-viewer y per-sesión (igual que el token organic); si no hay
 * sessionStorage, se degrada a null y el upsell usará lo que tenga.
 */
export interface OrganicOffer {
  birthDate: string;
  gender: string;
  smoker: boolean;
  capital: number;
  imc?: { value: number } | null;
  // Elegidos en el paso de preguntas (product-questions plegadas): fecha de
  // efecto (YYYY-MM-DD; la usa el select del upsell para materializar el fee) e
  // intención (loan/family/other; display en la confirmación).
  effectDate?: string;
  intention?: string;
}

const KEY = "l5_native_organic_offer";

export function storeOrganicOffer(offer: OrganicOffer): void {
  try {
    sessionStorage.setItem(KEY, JSON.stringify(offer));
  } catch {
    /* sin sessionStorage: el upsell caerá a lo que pueda */
  }
}

export function patchOrganicOffer(patch: Partial<OrganicOffer>): void {
  const current = readOrganicOffer();
  if (null === current) {
    return;
  }
  storeOrganicOffer({ ...current, ...patch });
}

export function readOrganicOffer(): OrganicOffer | null {
  try {
    const raw = sessionStorage.getItem(KEY);
    if (null === raw) {
      return null;
    }
    const parsed = JSON.parse(raw) as OrganicOffer;
    return "string" === typeof parsed.birthDate ? parsed : null;
  } catch {
    return null;
  }
}

/** IMC AGL de altura (cm) y peso (kg): round(10000·kg/cm², 1). Null si inválidos. */
export function imcFromHeightWeight(height: unknown, weight: unknown): { value: number } | null {
  const cm = Number(height);
  const kg = Number(weight);
  if (!Number.isFinite(cm) || !Number.isFinite(kg) || cm <= 0 || kg <= 0) {
    return null;
  }
  return { value: Math.round(((10000 * kg) / (cm * cm)) * 10) / 10 };
}
